var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3328 6.16667C15.3328 7.31594 14.8763 8.41814 14.0636 9.2308C13.2509 10.0435 12.1487 10.5 10.9995 10.5C9.8502 10.5 8.748 10.0435 7.93534 9.2308C7.12269 8.41814 6.66614 7.31594 6.66614 6.16667M1.93546 5.51817L1.17713 14.6182C1.01422 16.5731 0.932763 17.5505 1.26321 18.3045C1.55355 18.967 2.05659 19.5137 2.69267 19.8581C3.41665 20.25 4.39749 20.25 6.35916 20.25H15.6398C17.6015 20.25 18.5823 20.25 19.3063 19.8581C19.9424 19.5137 20.4454 18.967 20.7357 18.3045C21.0662 17.5505 20.9847 16.5731 20.8218 14.6182L20.0635 5.51816C19.9233 3.83615 19.8532 2.99514 19.4808 2.35859C19.1528 1.79806 18.6643 1.34865 18.0785 1.06833C17.4132 0.750001 16.5693 0.750001 14.8814 0.750001L7.1175 0.75C5.42965 0.75 4.58572 0.75 3.92045 1.06833C3.33461 1.34865 2.84619 1.79806 2.51819 2.35859C2.14571 2.99513 2.07563 3.83615 1.93546 5.51817Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBagIcon);
export default __webpack_public_path__ + "static/media/CartBagIcon.83ec0261a70f8c0f0b2d9275090524fd.svg";
export { ForwardRef as ReactComponent };